import React from 'react';
import PropTypes from 'prop-types';

import RBAC from '../../../../../common/rbac/RBAC';
import {
  mapComponentToResource,
  operations
} from '../../../../../common/rbac/constants';
import OutlierReadingModal from '../../../../../common/components/Chart/components/OutlierReadingModal';

const TagChartOutlierModal = ({
  visible,
  dataPos,
  dataPoint,
  onClose,
  markReadingAsOutlier,
  deleteOutlierReading
}) => {
  if (!visible) {
    return null;
  }

  return (
    <RBAC
      resource={mapComponentToResource.MachineCharts}
      operation={operations.Update}
      yes={(
        <OutlierReadingModal
          {...dataPos}
          height="192"
          width="250"
          dataPoint={dataPoint}
          markReadingAsOutlier={markReadingAsOutlier}
          deleteOutlierReading={deleteOutlierReading}
          close={onClose}
        />
      )}
    />
  );
};

TagChartOutlierModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  dataPos: PropTypes.object.isRequired,
  dataPoint: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  markReadingAsOutlier: PropTypes.func.isRequired,
  deleteOutlierReading: PropTypes.func.isRequired
};

TagChartOutlierModal.defaultProps = {
  dataPoint: null
};

export default TagChartOutlierModal;
